import React, { useContext } from "react"
import Icon from "@kit/design/icon"
import { OldButton } from "@kit/design/old-button"
import VisuallyHidden from "@kit/design/visually-hidden"
import { DiscoveryHubContext } from "./discovery-hub-context"
import Badge from "@kit/design/badge"
import { useFetch } from "hooks/use-new-fetch"
import pluralize from "pluralize"

export function DrawerHeading() {
  const [request] = useFetch("/onboarding/changelog_items/mark_all_as_read")
  const context = useContext(DiscoveryHubContext)
  const handleClick = async () => {
    await request.post({ path: "/" })
    context.setNotificationCounterToZero()
  }

  return (
    <div className="flex h-12">
      <div className="flex m-auto">
        <div style={{ marginTop: "2px" }}>
          <Icon name="alarm" />
        </div>

        <div className="ml-2 text-gray-900 text-lg mr-3">What’s New</div>

        {context.notificationCounter > 0 && (
          <Badge variant="light" className="m-auto mt-1">
            {context.notificationCounter}
            <VisuallyHidden>
              {" "}
              unread app{" "}
              {pluralize("notification", context.notificationCounter)}
            </VisuallyHidden>
          </Badge>
        )}
      </div>
      {context.notificationCounter > 0 && (
        <div className="ml-5">
          <OldButton
            is="tertiary"
            size="lg"
            disabled={context.notificationCounter < 1}
            onClick={handleClick}
          >
            Mark all as read
          </OldButton>
        </div>
      )}
    </div>
  )
}
